import { render, staticRenderFns } from "./IssueReasonReport.vue?vue&type=template&id=066481bf&"
import script from "./IssueReasonReport.vue?vue&type=script&lang=js&"
export * from "./IssueReasonReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports